import { Animated } from 'react-native';
export var getAnimatedWidth = (animatedWidth, endWidth) => {
  Animated.timing(animatedWidth, {
    toValue: endWidth,
    duration: 200,
    useNativeDriver: false
  }).start();
};
export var getDotAnimation = props => {
  var activeIndex = props.activeIndex,
    animatedDotScaling = props.animatedDotScaling,
    animatedRight = props.animatedRight,
    animationDuration = props.animationDuration,
    animatedDotSize = props.animatedDotSize,
    oldIndex = props.oldIndex;
  var indexDiff = activeIndex - oldIndex;
  var finalDotSize = animatedDotSize + 2;
  var scalingDirection = finalDotSize * (indexDiff > 0 ? 1 : -1);
  if (indexDiff != 0) {
    Animated.parallel([Animated.timing(animatedDotScaling, {
      toValue: 3,
      useNativeDriver: false,
      duration: animationDuration / 3
    }), Animated.timing(animatedRight, {
      toValue: oldIndex * finalDotSize * 2 + scalingDirection,
      useNativeDriver: false,
      duration: animationDuration / 3
    })]).start(() => {
      Animated.timing(animatedRight, {
        toValue: activeIndex * finalDotSize * 2 - scalingDirection,
        useNativeDriver: false,
        duration: animationDuration / 3
      }).start(() => {
        Animated.parallel([Animated.timing(animatedRight, {
          toValue: activeIndex * finalDotSize * 2,
          useNativeDriver: false,
          duration: animationDuration / 3
        }), Animated.timing(animatedDotScaling, {
          toValue: 1,
          useNativeDriver: false,
          duration: animationDuration / 3
        })]).start();
      });
    });
  }
};
export var getAutoPlayAnimation = props => {
  var activeIndex = props.activeIndex,
    animatedRight = props.animatedRight,
    animatedDotSize = props.animatedDotSize,
    autoPlayTransitionSpeed = props.autoPlayTransitionSpeed,
    animatedDotScaling = props.animatedDotScaling;
  var finalDotSize = animatedDotSize + 2;
  var xPosition = activeIndex * finalDotSize * 2 - activeIndex * 4;
  Animated.parallel([Animated.timing(animatedRight, {
    toValue: xPosition,
    useNativeDriver: false,
    duration: 0
  }), Animated.timing(animatedDotScaling, {
    toValue: 1,
    useNativeDriver: false,
    duration: 0
  })]).start(() => {
    Animated.parallel([Animated.timing(animatedDotScaling, {
      toValue: 5,
      useNativeDriver: false,
      duration: autoPlayTransitionSpeed
    }), Animated.timing(animatedRight, {
      toValue: xPosition + finalDotSize + 2,
      useNativeDriver: false,
      duration: autoPlayTransitionSpeed
    })]).start();
  });
};